import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
// import { UserService } from '../../service/user.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { RoleService } from 'src/app/service/role.service';
declare var $: any;

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {
  showLoader: boolean = true;
  data: any = [];
  // data = [
  //   {
  //     id: 1,
  //     name: "role1",
  //     active: "true"
  //   },
  //   {
  //     id: 2,
  //     name: "role2",
  //     active: "false"
  //   }
  // ];

  constructor(private toastrService: ToastrService, public globals: Globals, private router: Router,
    public translate: TranslateService, private roleService: RoleService) { }

  ngOnInit(): void {

    // $(document).ready(function () {
    //   this.updateTable();
    // });
    this.getAllRoles();
  }

  getAllRoles() {
    this.showLoader = true;
    this.roleService.getAllRoles().subscribe(
      data => {
        this.data = data;
        // console.log(data);
      },
      error => {
        this.updateTable();
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_ROLES"));
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
        this.updateTable();
      }
    );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [8] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        searching: false,
        // search: {
        //   searchPlaceholder: "Search",
        // },
        paging: true,
        // language: {
        //   search: "",
        //   searchPlaceholder: "Search",
        // },
        // buttons: [
        //   'excel', 'pdf'
        // ]
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV'
        },
        {
          extend: 'pdfHtml5',
          text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
          titleAttr: 'PDF'
        }]
      });
    }, 2);
  }

  updateRole(roleId: any) {
    this.router.navigate(
      ['update-role'],
      { queryParams: { roleId: roleId } });
  }

  // ngAfterViewInit() {
  //   this.updateTable();

  // }
}
